/*
 * @Author: tanyaohua
 * @Date: 2021-10-27 17:51:13
 * @LastEditTime: 2021-10-27 17:51:31
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\productManageMent.js
 * @Description: 
 */
'use strict';
angular.module('productManageMentModule', [
    'productManageMentRouterModule',
    'ui.bootstrap',
    'productManageMentLeftModule',
    'newspaperManageModule',
    'productManageMentWebsiteModule',
    'productManageMentServiceModule',
    'productManageMentWeiXinModule',
    'productManageMentAppModule',
    'productManageMentWeiboModule',
    'productManageMentServiceModule',
    'productManageMentDirModule',
    'televisionManageModule',
    'broadcastManageModule',
    'productManageMentTrillModule', // 新增抖音渠道
    'productManageMentBaijiahaoModule',
    'productManageMentTheWatermarkMgrModule', // 水印管理指令
    'productManageMentQiehaoModule',
    'productManageMentResetAccountOrderModule',
    'disableTheProduct', // 禁用产品指令
    'productManageMentToutiaohaoModule',
    'ProductManageMentKuaishouModule',
    'productManageMentShortVideoModule'
]).controller('productManageMentController', ['$scope', '$state', 'trsHttpService', '$modal', function($scope, $state, trsHttpService, $modal) {
    // 左边切换站点触发右边导航切换站点广播转发，因为左边和右边是父子关系，需要由共同父来转发
    $scope.$on('changeSiteToParent', function(event, value) {
        $scope.$broadcast('changeSiteToChildren', value);
    });
    $scope.$on('leftSaveWebSite', function(event, value) {
        $scope.$broadcast('leftSaveWebSiteToChildren', value);
    });
    $scope.$on('leftSaveApp', function(event, value) {
        $scope.$broadcast('leftSaveAppToChildren', value);
    });
    // console.log($scope.configureAccess);
}]);
